import { render, staticRenderFns } from "./ButtonMedium.vue?vue&type=template&id=1aa5c698&scoped=true"
import script from "./ButtonMedium.vue?vue&type=script&lang=js"
export * from "./ButtonMedium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa5c698",
  null
  
)

export default component.exports